<template>
  <div id="formTable">
    <div class="formTableItem">
      <p class="label">审核状态</p>
      <Select v-model="status" @on-change="selectChange">
        <Option
          v-for="(x, index) in $t('payStatus')"
          :key="index"
          :value="index"
          >{{ x.name }}</Option
        >
      </Select>
    </div>
    <div class="formTableItem">
      <p class="label">时间范围</p>
      <start-end ref="startEnd" timeModel="4,3,2"></start-end>
    </div>
    <div class="formTableItem">
      <p class="label">选择车辆</p>
      <selecAlotCCar ref="selecAlotCCar" @deviceIdList="reCars"></selecAlotCCar>
    </div>
    <div class="formTableItem">
      <Button @click="chaxun" class="chaxun">查询</Button>
      <Button @click="tianjia" class="chaxun">新增</Button>
      <Button @click="daoru" class="chaxun">导入</Button>
      <Button @click="daochu" class="chaxun">导出</Button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      status: "3",
      deviceIdList: [],
      openCarDrawer: false,
    };
  },
  methods: {
    daochu() {
      this.$emit("exportAll");
    },
    reCars(x) {
      console.log(x);
      this.$emit("cars", x);
    },
    tianjia() {
      this.$emit("reOpenWin");
    },
    daoru() {
      this.$emit("daoru");
    },
    selectChange(v) {
      this.$emit("selectChange", v);
    },
    chaxun() {
      var v = this.$refs.startEnd.getTimeObj();
      this.$emit("timeObj", v);
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/payTool.vue